import { useTableCellHoverPreviewDispatchOptional } from '../../../../domain/tableCellHover/useTableCellHoverPreview';
import styles from './CellHoverPreviewWrapper.module.css';

/**
 * Static table-cell shell when hoverUrl is set: forwards pointer events to the
 * grid-level preview overlay. No fetch, no popover, no per-cell hooks besides
 * a stable dispatch context.
 * @param {object} props
 * @param {string} props.hoverUrl - URL to fetch HTML from
 * @param {React.ReactNode} props.children - Inner cell (direct edit + value)
 * @returns {JSX.Element}
 */
function CellHoverPreviewWrapper({
  hoverUrl,
  children,
}) {
  const {
    setHoveredPreview,
    updateCursorPosition,
    leaveHoveredPreview,
  } = useTableCellHoverPreviewDispatchOptional();

  if (!hoverUrl) {
    return <div className={styles.wrapper}>{children}</div>;
  }

  return (
    <div
      className={styles.wrapper}
      onMouseEnter={(e) => {
        setHoveredPreview(hoverUrl, e.currentTarget);
        updateCursorPosition(e);
      }}
      onMouseMove={updateCursorPosition}
      onMouseLeave={leaveHoveredPreview}
    >
      {children}
    </div>
  );
}

export default CellHoverPreviewWrapper;
